export default {
  data: () => ({
    paletteScanobar: {
      primary: '#29BAB7',
      red: '#EE6E4E',
      black: '#4D4D4D'
    }
  })
}
